<template>
    <div data-testid="header-search-button">
        <VJoyDialogTrigger :dialog="dialog">
            <VJoyButton class="header-search-button" size="small" data-testid="navbar-search-button" icon="search" variant="secondary">
                {{ searchPlaceholderText }}
            </VJoyButton>
        </VJoyDialogTrigger>

        <VJoyDialog ref="dialog" class="header-search-dialog">
            <template #dialog-body>
                <div class="menu-content" role="menuitem" aria-label="search-pannel">
                    <SliceZone v-if="headerSearchSlice" :slices="[headerSearchSlice]" :components="components" />
                </div>
            </template>
        </VJoyDialog>
    </div>
</template>

<script setup lang="ts">
    import {useTemplateRef} from 'vue';
    import {components} from '@navbar-unlogged/slices';
    import {SliceZone} from '@prismicio/vue';
    import type {HeaderSearchSliceSlice} from '@prismicio-types';
    import {VJoyButton, VJoyDialog, VJoyDialogTrigger} from '@maltjoy/core-vue';

    interface Props {
        headerSearchSlice: HeaderSearchSliceSlice;
        searchPlaceholderText: string;
    }
    defineProps<Props>();

    const dialog = useTemplateRef('dialog');
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .header-search-button {
        display: none !important;
        padding: var(--joy-core-spacing-2) var(--joy-core-spacing-5) var(--joy-core-spacing-2) var(--joy-core-spacing-5) !important;

        @include mq.screen_sm {
            font-size: var(--joy-font-size-primary-200) !important;
            min-height: 0 !important;
            background-size: var(--joy-core-spacing-4) var(--joy-core-spacing-4);
        }

        @include mq.screen_sm(min) {
            display: flex !important;
        }
    }

    .header-search-dialog {
        padding: 0 !important;

        .joy-dialog--header {
            height: 72px;
            box-shadow: var(--joy-core-elevation-1);
        }

        .joy-dialog--close {
            top: var(--joy-core-spacing-5) !important;
        }

        .joy-dialog--wrapper {
            animation: none !important;
            transition: none !important;
            transform: none !important;
            opacity: 1 !important;
        }

        .joy-dialog--body {
            overflow: visible;
        }

        .joy-dialog__inner {
            width: 100%;
            height: 100%;
            max-height: 100%;
            padding: 0;
            border-radius: 0;
        }
    }
</style>
